<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="`Entidade ${entidade.id} - Registros`">
          <template v-slot:preview>
            <v-col>
              <div
                v-for="en in entidadePropriedades"
                :key="en.id"
                class="d-flex flex-row mt-2 mb-2"
              >
                <span class="font-weight-black" style="font-size: 16px"
                  >{{ en.grupoPropriedade.nome }}:</span
                >&nbsp;
                <span style="font-size: 16px">{{ en.valor }}</span>
              </div>
            </v-col>
            <v-divider></v-divider>
            <v-col>
              <v-row class="pl-3">
                <v-btn
                  @click="dialogPendencia = true"
                  title="Criar Pendencia"
                  color="success"
                  :disabled="!verficiarPermissao(1)"
                  small
                >
                  <v-icon class="mr-4" small>fa fa-plus</v-icon>
                  Criar Pendencia
                </v-btn>
              </v-row>
            </v-col>
            <v-row class="pa-5">
              <v-col cols="6">
                <v-select
                  :items="tipoAgrupamento"
                  label="Agrupamento"
                  item-text="nome"
                  item-value="tipo"
                  v-model="agrupamento"
                  @change="handleAgrupamento()"
                  required
                ></v-select>
              </v-col>
            </v-row>

            <v-row
              v-if="!carregandoHistorico"
              class="pa-5"
              justify="space-between"
            >
              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="registro in registros"
                    :key="registro.id"
                  >
                    <v-expansion-panel-header>
                      <v-row>
                        <v-col cols="11">
                          {{ registro.descricao }}
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div>
                        <v-row>
                          <v-col cols="6" offset="6">
                            <v-text-field
                              v-model="search"
                              append-icon="search"
                              label="Pesquisa"
                              single-line
                              hide-details
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-data-table
                          :headers="headersRegistros"
                          :items="registro.registros"
                          :search="search"
                        >
                          <template v-slot:item="{ item }">
                            <tr>
                              <td>{{ item.id }}</td>
                              <td>{{ item.documento.nome }}</td>
                              <td>
                                {{ item.periodoExibicao }}
                              </td>
                              <td>
                                {{
                                  item.validade
                                    ? formatDate(item.validade)
                                    : "-"
                                }}
                              </td>
                              <td style="width: 15%">
                                <v-row>
                                  <v-col>
                                    <v-btn
                                      color="primary"
                                      fab
                                      x-small
                                      dark
                                      title="Visualizar Histórico"
                                      @click="selecionarRegistro(item)"
                                      ><v-icon> mdi-eye</v-icon></v-btn
                                    >
                                  </v-col>
                                </v-row>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-alert
                  outlined
                  type="success"
                  v-if="pesquisado && !registros.length"
                  >Não há nenhum registro vinculado ainda</v-alert
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn @click="voltar" color="error" class="mr-2">Voltar</v-btn>
              </v-col>
            </v-row>
            <v-dialog v-model="dialog" max-width="90%">
              <v-card>
                <v-card-title>
                  <span class="headline">Versões do Registro</span>
                </v-card-title>
                <v-card-text>
                  <v-col v-if="botaoGerarPendencia">
                    <v-row class="pl-3">
                      <v-btn
                        @click="criarPendenciaRegistro()"
                        :disabled="!verficiarPermissao(1)"
                        title="Gerar pendencia desse registro"
                        color="success"
                        small
                      >
                        <v-icon class="mr-4" small>fa fa-plus</v-icon>
                        Gerar pendencia desse registro
                      </v-btn>
                    </v-row>
                  </v-col>
                  <historico-registro
                    :registroSelecionado="registroSelecionado"
                    @inativar-registro="
                      () => {
                        dialog = false;
                        handleAgrupamento();
                      }
                    "
                  ></historico-registro>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false">
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogPendencia" max-width="50%">
              <v-card>
                <v-card-title>
                  <span class="headline">Criar Pendencia</span>
                </v-card-title>
                <v-card-text>
                  <v-row class="pa-5">
                    <v-col cols="6">
                      <v-select
                        :items="documentosPendencias"
                        label="Documento"
                        item-text="nome"
                        item-value="id"
                        v-model="documentoCriarPendencia"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="documentoCriarPendencia == null"
                    color="success"
                    text
                    @click="criarPendenciaManual()"
                  >
                    Criar
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialogPendencia = false"
                  >
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <CriarPendenciaDialog
      :dialog="dialogCriarPendencia"
      :registro="registroSelecionado"
      :usuarioID="usuario.usuario.id"
      @sync-dialog="criarPendenciaDialogSync"
    ></CriarPendenciaDialog>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import HistoricoRegistro from "../../../components/HistoricoRegistro.vue";
import SweetAlert from "@/common/services/sweetalert.service";
import CriarPendenciaDialog from "./CriarPendenciaHistorico/CriarPendenciaDialog.vue";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  name: "entidade",
  data() {
    return {
      search: "",
      pesquisado: false,
      dialog: false,
      dialogPendencia: false,
      dialogCriarPendencia: false,
      documentosPendencias: [],
      page: 1,
      itemsPerPage: 1,
      entidade: {
        id: 0,
      },
      entidadePropriedades: [],
      registroSelecionado: null,
      botaoGerarPendencia: false,
      registros: [],
      documentoCriarPendencia: null,
      registroVersao: null,
      headersRegistros: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "documento.nome" },
        { text: "Periodo", value: "periodoExibicao" },
        { text: "Validade", value: "validade" },
        { text: "", value: "" },
      ],
      headers: [
        { text: "ID", value: "id" },
        { text: "Status", value: "validado" },
        { text: "Criado por", value: "criadoPor" },
        { text: "Validado Por", value: "usuarioValidacao.nome" },
        { text: "Data Validação", value: "dataValidacaoExibicao" },
        { text: "Observação", value: "observacoes" },
        { text: "", value: "" },
      ],
      cliente: {},
      usuario: {},
      tipoAgrupamento: [
        { nome: "Periodo", tipo: 1 },
        { nome: "Documento", tipo: 2 },
      ],
      carregandoHistorico: false,
      agrupamento: 1,
    };
  },
  components: {
    KTCodePreview,
    HistoricoRegistro,
    CriarPendenciaDialog,
  },
  methods: {
    async criarPendenciaManual() {
      const { data: result } = await ApiService.post(
        `Registro/CriarPendenciaManual/${this.entidade.id}/${this.documentoCriarPendencia}`
      );

      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Pendencia gerada com sucesso!",
          showConfirmButton: false,
          timer: 1500,
        });
        this.dialogPendencia = false;
      } else SweetAlert.sweetAlertError(result.errors);
    },
    verficiarPermissao(permissoes) {
      return PermissoesService.verificarAcesso(Modulo.Pendencia, permissoes);
    },
    criarPendenciaDialogSync(obj) {
      this.dialogCriarPendencia = obj.dialog;
      this.dialog = false;
      this.handleAgrupamento();
    },
    async pesquisarEntidade() {
      const { data: result } = await ApiService.get(
        `Entidade/getbyid/${this.entidade.id}`
      );

      if (result.success) {
        this.entidadePropriedades = result.data.entidadePropriedades;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    criarPendenciaRegistro() {
      this.dialogCriarPendencia = true;
    },

    async pesquisarDocumentosParaCriarPendencias() {
      const { data: result } = await ApiService.get(
        `Documento/DocumentosParaCriarPendencias/${this.entidade.id}`
      );

      if (result.success) {
        this.documentosPendencias = result.data;
      } else SweetAlert.sweetAlertError(result.errors);
    },
    downloadImagem(url) {
      window.open(url);
    },
    handleAgrupamento() {
      if (this.agrupamento === 1) {
        this.listarHistoricoAgrupadoPorPeriodo();
      } else {
        this.listarHistoricoAgrupadoPorDocumento();
      }
    },

    async listarHistoricoAgrupadoPorDocumento() {
      this.registros = [];
      const { data: result } = await ApiService.get(
        `Entidade/GetRegistrosByEntidadeIDAgrupadosPorDocumento/${this.entidade.id}`
      );

      this.pesquisado = true;

      if (result.success) {
        this.registros = result.data;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    voltar() {
      this.$router.push({ name: "entidade" });
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },

    async listarHistoricoAgrupadoPorPeriodo() {
      this.registros = [];
      const { data: result } = await ApiService.get(
        `Entidade/GetRegistrosByEntidadeIDAgrupadosPorPeriodo/${this.entidade.id}`
      );

      this.pesquisado = true;

      if (result.success) {
        this.registros = result.data;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    async listarRegistroVersao(registroID) {
      const { data: result } = await ApiService.get(
        `RegistroVersao/listar/registro/${registroID}`
      );

      if (result.success) {
        return result.data;
      }

      return [];
    },
    async selecionarRegistro(registro) {
      registro.registroVersao = await this.listarRegistroVersao(registro.id);

      this.registroSelecionado = null;
      this.registroSelecionado = registro;

      if (
        registro.registroVersao != null &&
        registro.registroVersao.length > 0
      ) {
        const ultimoRegistroVersao =
          registro.registroVersao[registro.registroVersao.length - 1];

        this.botaoGerarPendencia = ultimoRegistroVersao.validado;
      }

      this.registroVersao = null;
      this.dialog = true;
    },
  },
  beforeMount() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));
    this.entidade.id = this.$route.params.entidadeid;
    this.pesquisarDocumentosParaCriarPendencias();
    this.pesquisarEntidade();
    this.listarHistoricoAgrupadoPorPeriodo();
  },
};
</script>
